import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('pqEo4mApcnStore', Object.keys(getters)),
	...mapState('pqEo4mApcnStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('pqEo4mApcnStore', Object.keys(actions)),
	...mapMutations('pqEo4mApcnStore', Object.keys(mutations))
};
